import { render, staticRenderFns } from "./PostCard.htm?vue&type=template&id=51849dca&scoped=true&external"
import script from "./PostCard.js?vue&type=script&lang=js&external"
export * from "./PostCard.js?vue&type=script&lang=js&external"
import style0 from "./PostCard.scss?vue&type=style&index=0&id=51849dca&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51849dca",
  null
  
)

export default component.exports